var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"c_cs_link",attrs:{"href":_vm.getHrefs(),"target":_vm.newWindow() ? '_blank' : null}},[_c('IconSVG',{attrs:{"handle":_vm.getIcon(),"color":"black","aria-hidden":""}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.linkLabel))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }